import { Card, Flex, Typography } from '@iheartjane/reefer';
import { Controller, useFormContext } from 'react-hook-form';

import { QuillEditor } from '@jane/business-admin/components';
import type { BloomFooterTemplate } from '@jane/business-admin/types';

import styles from './Footer.module.css';

export const TextAreaSection = () => {
  const { control } = useFormContext<BloomFooterTemplate>();

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="text_content"
    >
      <Flex flexDirection="column" gap={16} p={40}>
        <Typography variant="header-bold">Text area</Typography>
        <Typography>
          Use this area to add any large body of text. It will appear at the
          bottom of your footer.
        </Typography>

        <Controller
          name="text_content"
          control={control}
          render={({ field }) => (
            <QuillEditor
              {...field}
              value={field.value ?? ''}
              onChange={field.onChange}
            />
          )}
        />
      </Flex>
    </Card>
  );
};
